import MenuCard from './MenuCard';
export { MENU_CARD_WIDTH } from './MenuCard';
export default MenuCard;
